// extracted by mini-css-extract-plugin
export default {"ItemsView":"ItemsView_ItemsView__h9355"};